import { render, staticRenderFns } from "./TableCreditOffered.vue?vue&type=template&id=0ff9d3ba&scoped=true&"
import script from "./TableCreditOffered.vue?vue&type=script&lang=js&"
export * from "./TableCreditOffered.vue?vue&type=script&lang=js&"
import style0 from "./TableCreditOffered.vue?vue&type=style&index=0&id=0ff9d3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9d3ba",
  null
  
)

export default component.exports